import { EmptyNavPageContainer } from '../components/layout/EmptyNavPageContainer/EmptyNavPageContainer'
import { Routes } from '@dtx-company/true-common/src/constants/routes'
import { SigninPageContainer } from '../containers/authentication/SigninPageContainer/SigninPageContainer'
import { buildServerSideProps } from '@dtx-company/app/shared/common/src/utils/buildServerSideProps'
import { deserializePlanTypeQueryParam } from '@dtx-company/true-common/src/query-string-serialization/planType/deserializePlanTypeQueryParam'
import {
  getAccessTokenFromCookies,
  getImpersonationTokenFromCookies,
  removeF2RedirectCookie
} from '../utils/auth'
import { getInviteState } from '../utils/invite'
import { signinPagePrismicDocument } from '../components/pages/SigninPage/__mocks__/signinPagePrismicDocument'
import Head from 'next/head'
import type { FC } from 'react'
import type { GetServerSideProps } from 'next'
import type { SignInPageProps } from '../containers/authentication/SigninPageContainer/SigninPageContainer.types'

export const getServerSideProps: GetServerSideProps = buildServerSideProps(async context => {
  // Determine if we are coming from flowpage or not so we can render the
  // correct text on the server-side (avoiding a hydration issue)
  const fromFlowpage = context.query.flowpage === 'true'
  const prismicData = signinPagePrismicDocument
  const ctxPlanType = context.query.planType
  const planTypeQueryParams = ctxPlanType
    ? deserializePlanTypeQueryParam(ctxPlanType.toString())
    : ''
  const inviteState = getInviteState(context)

  removeF2RedirectCookie(context)

  const accessToken = getAccessTokenFromCookies(context.req.cookies)
  const impersonationAccessToken = getImpersonationTokenFromCookies(context.req.cookies)
  const token = impersonationAccessToken ?? accessToken

  const isLoggedIn = !!token

  if (isLoggedIn) {
    return {
      redirect: {
        permanent: false,
        destination: Routes.HOME
      },
      props: { fromFlowpage, prismicData, inviteState, planTypeQueryParams }
    }
  }

  return {
    props: { fromFlowpage, prismicData, inviteState, planTypeQueryParams }
  }
})

const SigninPage: FC<SignInPageProps> = ({
  fromFlowpage,
  prismicData,
  inviteState,
  planTypeQueryParams
}) => {
  return (
    <EmptyNavPageContainer page={Routes.SIGN_IN}>
      {prismicData?.background?.url && (
        <Head>
          <link rel="preload" as="image" href={prismicData.background.url} />
        </Head>
      )}
      <SigninPageContainer
        prismicData={prismicData}
        fromFlowpage={fromFlowpage}
        inviteState={inviteState}
        planTypeQueryParams={planTypeQueryParams}
      />
    </EmptyNavPageContainer>
  )
}

export default SigninPage
